var _defs, _path, _g, _path2, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgObjects04(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1500 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ad4112;}.cls-2{fill:#e1dacf;}.cls-3{clip-path:url(#clip-path);}.cls-4,.cls-5,.cls-6{fill:none;stroke-miterlimit:10;}.cls-4,.cls-5{stroke:#d67347;}.cls-5,.cls-6{stroke-linecap:round;stroke-width:3px;}.cls-6{stroke:#000;}.cls-7{clip-path:url(#clip-path-2);}.cls-8{fill:#fff;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.67,898.59c13.46,26.17,28.77,55,56.44,65,29.95,10.83,65.38-6.77,80.37-34.87s11.95-63.31-1.76-92.05-36.89-51.89-61.6-72-51.39-37.74-75.07-59a324.37,324.37,0,0,1-80.39-111.6c-11.55-26.58-19.47-54.61-30.61-81.38s-26-52.82-48.42-71.17-53.62-27.86-81.2-18.93c-25.52,8.26-54,43.69-41.91,71.66,6.66,15.38,24.72,29.07,35.72,41.48q20.75,23.41,40.65,47.55a1769.15,1769.15,0,0,1,140.38,196Q797.27,837.62,828.67,898.59Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.52,426c18.67-.14,39.64.87,53.3-11.86,13.12-12.23,14.17-32.56,12-50.37A208.72,208.72,0,0,0,647.08,184.62a15.53,15.53,0,0,0-18,10.84c-23.87,80.9-85.73,150-163.88,181.93-18.94,7.74-39.53,13.93-53.62,28.76C387,432,392.12,476.05,414.14,504c15.72,20,38.11,33.64,61.26,43.44,27.06,11.45,40.67,7.7,58.86-15,32.87-41,75.39-72.66,125-90.57A263.43,263.43,0,0,1,746.52,426Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "objects") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M828.67,898.59c13.46,26.17,28.77,55,56.44,65,29.95,10.83,65.38-6.77,80.37-34.87s11.95-63.31-1.76-92.05-36.89-51.89-61.6-72-51.39-37.74-75.07-59a324.37,324.37,0,0,1-80.39-111.6c-11.55-26.58-19.47-54.61-30.61-81.38s-26-52.82-48.42-71.17-53.62-27.86-81.2-18.93c-25.52,8.26-54,43.69-41.91,71.66,6.66,15.38,24.72,29.07,35.72,41.48q20.75,23.41,40.65,47.55a1769.15,1769.15,0,0,1,140.38,196Q797.27,837.62,828.67,898.59Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M1077,709.83,1063,754.12c-5.19,16.49-10.4,33.08-12.71,50.22-1,7.8-1.49,15.66-1.94,23.52l-.34,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M917.24,755.79c-16.34,39.3-23.38,84.35-9.14,124.46s53.53,72.87,96,70.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M953.47,807.65c-11.14,6-15.68,21.35-10.43,32.86s18.94,18.16,31.43,16.14,23.07-12,26.9-24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M853.87,704.05c18.27,25,19.65,58.79,13.8,89.19s-18,59.25-24.66,89.49-7,63.77,9.33,90.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M736.48,492.06l-5.78,72.16c-2.29,28.73-4.56,58,1.94,86.07s23.25,55.28,49.54,67.09,62.14,3.33,74.87-22.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M705.85,457.39c-27.62,57.2-29.75,126.15-5.72,185,16.53,40.45,44.23,75.14,67.79,111.95s43.67,78.37,41.93,122"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M607.09,433.66a274.4,274.4,0,0,1-7,173.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M580.31,466.1A125.83,125.83,0,0,1,559.51,547"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M668.47,417.23A521.79,521.79,0,0,0,683.31,735"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M896.31,745c.14,47.41-26.61,91.5-28.43,138.88-2,51.36,28.54,102.55,74.65,125.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M764.2,619.08c-2.6,10-5.23,20.31-4,30.58s7.25,20.65,17,24c8.11,2.75,17.27.15,24.31-4.71s12.39-11.77,17.61-18.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M821.42,827.57s44,133.91,111.9,114.65"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M746.52,426c18.67-.14,39.64.87,53.3-11.86,13.12-12.23,14.17-32.56,12-50.37A208.72,208.72,0,0,0,647.08,184.62a15.53,15.53,0,0,0-18,10.84c-23.87,80.9-85.73,150-163.88,181.93-18.94,7.74-39.53,13.93-53.62,28.76C387,432,392.12,476.05,414.14,504c15.72,20,38.11,33.64,61.26,43.44,27.06,11.45,40.67,7.7,58.86-15,32.87-41,75.39-72.66,125-90.57A263.43,263.43,0,0,1,746.52,426Z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M758.55,284.59s69.29,119.24-16.93,119.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M681.68,220.47l25.86,18.22a28.2,28.2,0,0,1,6.79,6c1.79,2.45,2.75,5.72,1.73,8.57s-4.45,4.87-7.24,3.69-3.75-4.72-5-7.59-4.35-5.78-7.05-4.24c-2.45,1.39-2,5.11-.58,7.54s3.57,4.68,3.6,7.49c0,4.78-6.59,7.27-10.77,5s-6-7.35-6.75-12.06c-.51-3.27-.67-6.66-2-9.68-1.85-4.14-5.66-7-9.36-9.63s-7.6-5.31-9.75-9.3-1.89-9.7,1.83-12.29c2.42-1.68,5.71-1.65,8.48-.66a27.84,27.84,0,0,1,7.47,4.66l18.77,14.66"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjects04);
export default __webpack_public_path__ + "static/media/objects-04.2af1ecd06d8c6e5820f8b398706b74ec.svg";
export { ForwardRef as ReactComponent };